import Lookup from 'src/componentes/select2';

const StatusAcao = (props) => {
  return (
    <Lookup
      clearable={false}
      labelKey="descricao"
      valueKey="id"
      url="/StatusAcaoLookup"
      {...props}
    />
  );
};

export default StatusAcao;
